export default __webpack_public_path__ + "static/1-9f7b8b051e6c756e0cc951a4638c2f11.jpg";